module.exports = __webpack_public_path__ + "static/media/category4.041ccf96.jpg";